import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyLetters]',
})
export class OnlyLettersDirective {
  @Input('typeDirective') tipo: any;
  public regex: RegExp = new RegExp(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+$/);
  constructor(private el: ElementRef, private control: NgControl) {}
  @HostListener('input', ['$event'])
  onInput(event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
    input.value = input.value.replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ\s]/g, '');
    this.control.control.patchValue(input.value);
  }

  @HostListener('blur', ['$event'])
  onblur(event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.trim();
    this.control.control.patchValue(input.value);
  }
}
